import { queryKeys } from '@/lib/query-keys';
import { apiClient } from '@borradh-workspace/api-client';
import type {
  ClaireTurnsReport,
  ListClaireTurnsInput,
} from '@borradh-workspace/api-client/types';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const fetchClaireTurns = (
  filter: ListClaireTurnsInput,
  signal?: AbortSignal
) => {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(filter))
    if (v !== undefined && v !== null) params.set(k, String(v));
  return apiClient.get<ClaireTurnsReport>(
    `admin-terminal/claire-turns?${params.toString()}`,
    { signal }
  );
};

export const claireTurnsQueryOptions = (filter: ListClaireTurnsInput) =>
  queryOptions({
    queryKey: queryKeys.adminTerminal.claireTurns(filter),
    queryFn: ({ signal }) => fetchClaireTurns(filter, signal),
    staleTime: 5 * 60_000,
  });

/** The turns behind a number on the Claire quality page; off while null. */
export const useClaireTurns = (filter: ListClaireTurnsInput | null) =>
  useQuery({
    ...claireTurnsQueryOptions(filter ?? { source: 'live', from: '', to: '' }),
    enabled: filter !== null,
  });
